import { useQuery as useTanstackQuery } from '@tanstack/react-query';

import { buildQueryDescriptor } from './utils';


function useBaseQuery(url, client, params) {
  const { queryKey, queryFn, restParams } = buildQueryDescriptor(url, client, params);
  const query = useTanstackQuery({ queryKey, queryFn, retry: 1, ...restParams });

  return { ...query, queryKey };
}

export default useBaseQuery;
